import * as React from 'react';
import {
  motion,
} from 'framer-motion';

import {
  Lang,
  Breakpoint,
  Colors,

  useDimensions,

  TextBlock,
} from '@bluecurrent/web-component-lib';

import Setup from '../../../../config/Setup.config';

import useSanityData from '../../../../hooks/useSanityData';

import handleLocalUrlChange from '../../../../functions/handleLocalUrlChange';
import handleHeadingPrioritization from '../../../../functions/handleHeadingPrioritization';

import getProductDisplayReferences from '../../../../services/Sanity/query/getProductDisplayReferences';

import Card from './Card';
import CardWrapper from './CardWrapper';

export default function Display(props) {
  const { i18n } = Lang.useTranslation();
  const size = useDimensions();
  const getData = useSanityData(
    /* eslint-disable-next-line no-underscore-dangle */
    getProductDisplayReferences(props.data.products.map((e) => e._ref)),
  );

  const lang = Setup.PSEUDO ? Setup.FALLBACK_LANG : i18n.language;
  const filteredData = getData.filter((e) => e.slug !== props.slug);

  const arrayWithOriginalId = filteredData.map((i, index) => ({
    original_id: index,
    ...i,
  }));

  const [data, setData] = React.useState([]);
  const [isLoading, setLoading] = React.useState(true);

  React.useEffect(() => {
    setLoading(false);
  }, []);

  const layoutHandler = (row, item, index) => {
    if (
      row.length === 1
      && (index + 1) === row.length
      && item.config.image !== undefined
      && size.width >= Breakpoint.sm
    ) {
      return 'horizontal';
    }
    return 'vertical';
  };

  const responsive = () => {
    if (size.width < Breakpoint.sm) {
      return {
        width: '100%',
        layout: 1,
      };
    }
    if (
      filteredData.length % 2 === 0
      || (size.width >= Breakpoint.sm && size.width < Breakpoint.lg)
    ) {
      return {
        width: `calc(50% - ${data.length === 1 ? 7.5 : 15}px)`,
        layout: 2,
      };
    }
    return {
      width: `calc(${parseFloat(100 / 3)}% - ${data.length === 1 ? 15 : 30}px)`,
      layout: 3,
    };
  };

  React.useEffect(() => {
    const array = [];

    for (let i = 0; i < arrayWithOriginalId.length; i += responsive().layout) {
      array.push(arrayWithOriginalId.slice(i, i + responsive().layout));
    }

    setData(array);
  }, [
    size,
    getData,
  ]);

  return (
    <motion.div
      initial={{
        opacity: 0,
      }}
      whileInView={{
        opacity: 1,
      }}
      transition={{
        duration: 0.5,
        ease: 'easeInOut',
        stiffness: 100,
      }}
      viewport={{
        once: true,
      }}
    >
      {
        (
          props.data?.text_block?.title
          || props.data?.text_block?.text
        ) && (
          <TextBlock
            title={{
              content: (!isLoading && props.data.text_block.title !== undefined) && (
                props.data.text_block.title[lang]
              ),
              portableText: !isLoading && props.data.text_block.title !== undefined,
              fontSize: '2.5em',
              heading: handleHeadingPrioritization(props.params.index),
            }}
            text={{
              content: (!isLoading && props.data.text_block.text !== undefined) && (
                props.data.text_block.text[lang]
              ),
              portableText: !isLoading && props.data.text_block.text !== undefined,
              color: Colors.GREY,
            }}
            align={
              size.width < Breakpoint.sm
                ? props.data.text_block.align
                : 'center'
            }
            buttons={
              props.data.text_block.buttons !== undefined
              && props.data.text_block.buttons.map((item) => ({
                /* eslint-disable no-underscore-dangle */
                id: item._key,
                text: item.link.text === 'custom' ? item.link.custom_text[lang] : item.link.text[lang],
                colorScheme: item.colorscheme,
                onClick: () => window.open(handleLocalUrlChange(item.link.url), item.link.target),
              }))
            }
          />
        )
      }
      <div
        style={{
          marginTop: 30,
        }}
      >
        {
          !isLoading && data.map((row, index) => (
            <div
              /* eslint-disable-next-line react/no-array-index-key */
              key={index}
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: data.length === 1 ? 15 : 30,
                marginBottom: data.length !== index + 1 ? 30 : 0,
                width: '100%',
              }}
            >
              {
                row.map((item, i) => (
                  <a
                    key={item._id}
                    href={handleLocalUrlChange(item.config.link.url)}
                    target={item.config.link.target}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      width: layoutHandler(row, item, i) === 'horizontal' ? '100%' : responsive().width,
                    }}
                  >
                    <CardWrapper
                      data={item}
                      layout={layoutHandler(row, item, i)}
                    >
                      <Card
                        data={item}
                        length={filteredData.length}
                        layout={layoutHandler(row, item, i)}
                      />
                    </CardWrapper>
                  </a>
                ))
              }
            </div>
          ))
        }
      </div>
    </motion.div>
  );
}
